import React from "react"
import {Box, Step, StepLabel, Stepper, styled} from "@mui/material"

const LocalStepLabel = styled(StepLabel)(({theme}) => ({
    '& .MuiStepIcon-root': {
        '&.Mui-active': ({
            ...theme.WORKFLOWSTEPPER
        }),
    },
}))

export const WorkflowStepper = ({
                                    orderedSteps,
                                }) => {
    return <Box pt={4}>
        <Stepper nonLinear>
            {orderedSteps.map(({title, isActive}) => (
                <Step key={title} completed={false} active={isActive}>
                    <LocalStepLabel>
                        {title}
                    </LocalStepLabel>
                </Step>
            ))}
        </Stepper>
    </Box>
}